import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerBackendAdminSetzenAdmin laden';
export const POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerBackendAdminSetzenAdmin ausführen';
export const POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerBackendAdminSetzenAdmin laden erfolgreich';
export const POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerBackendAdminSetzenAdmin Ladefehler';
export const POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerBackendAdminSetzenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerBackendAdminSetzenAdminAction implements Action {
    readonly type = POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN;
        constructor(public benutzerBackendAdminRequest: api.BenutzerBackendAdminRequest, public optPayload: any = null) {}
    }
export class PostBenutzerBackendAdminSetzenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerBackendAdminRequest: api.BenutzerBackendAdminRequest, public optPayload: any = null) {}
    }
export class PostBenutzerBackendAdminSetzenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerBackendAdminRequest: api.BenutzerBackendAdminRequest, public optPayload: any = null) {}
    }
export class PostBenutzerBackendAdminSetzenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerBackendAdminRequest: api.BenutzerBackendAdminRequest, public optPayload: any = null) {}
    }
export class PostBenutzerBackendAdminSetzenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerBackendAdminSetzenAdminActions =
    PostBenutzerBackendAdminSetzenAdminAction
    | PostBenutzerBackendAdminSetzenAdminAusfuehrenAction
    | PostBenutzerBackendAdminSetzenAdminErfolgreichAction
    | PostBenutzerBackendAdminSetzenAdminFehlerAction
    | PostBenutzerBackendAdminSetzenAdminNichtAusgefuehrtAction
    ;
